export default __webpack_public_path__ + "static/media/guide-man.61baa357.png";